var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.413 11.034h-9.297A2.616 2.616 0 0 0 8.49 13.64v7.266H4.618A2.616 2.616 0 0 1 2 18.293V4.613A2.62 2.62 0 0 1 4.618 2h9.305c5.328 0 9.634 4.262 9.592 9.537a9.684 9.684 0 0 0-3.102-.503zm3.102.503c3.9 1.306 6.665 5.023 6.476 9.369-.216 5.037-4.368 9.047-9.465 9.047H11.11a2.616 2.616 0 0 1-2.62-2.613v-6.42h5.552c5.09 0 9.249-4.018 9.466-9.048.007-.112.007-.223.007-.335z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBel);
export default __webpack_public_path__ + "static/media/BEL.c05f9aa735a079778f67de8d9f40238a.svg";
export { ForwardRef as ReactComponent };